<!--
 date One组件，可以倒计时选择，选择某一天的时间
 反馈记录版块在用
 -->
<template>
  <span>
  <DatePicker type="datetime" style="width: 200px" format="yyyy-MM-dd HH:mm" @on-change="change" :transfer="true" v-show="!check"></DatePicker>

  <span v-show="check">
    <InputNumber v-model="day" :min="0" @on-change="c"></InputNumber>天
    <InputNumber v-model="hh" :min="0" @on-change="c"></InputNumber>小时
    <InputNumber v-model="mm" :min="0" @on-change="c"></InputNumber>分钟 后提醒
    （提示时间：<font color="orange">{{value}}</font>）
  </span>
    <Checkbox v-model="check">倒计时</Checkbox>
  </span>
</template>

<script>
  export default {
    props:['value'],
    data(){
      return{
        check:true,
        // val:this.value,
        day:0,
        hh:0,
        mm:0,
      }
    },
    methods:{
      change(val){
        this.$emit('input',val);
      },
      c(){
        var len = this.day * 24 * 3600 * 1000;
        len+= this.hh * 3600 * 1000;
        len+= this.mm * 60 * 1000;
        var timestamp = Date.parse(new Date());
        timestamp = timestamp+len;
        var time = this.format(timestamp);
        this.$emit('input',time);
      },
      format(shijianchuo){
        var time = new Date(shijianchuo);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm);
      },
      add0(m){
        return m<10?'0'+m:m;
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/public/date/DateOne.vue